import { useLocation, useNavigate } from "react-router-dom";
import { Briefcase, FileText, User, Heart, LayoutDashboard } from "lucide-react";

export default function TelegramBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { to: "/applier/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/jobs", label: "Jobs", icon: Briefcase },
    { to: "/applier/dashboard?tab=saved", label: "Saved", icon: Heart },
    { to: "/applier/applications", label: "Apps", icon: FileText },
    { to: "/profile", label: "Profile", icon: User },
  ];

  const isActive = (to) => {
    const [path, query] = to.split("?");
    if (query) {
      const params = new URLSearchParams(query);
      const current = new URLSearchParams(location.search);
      if (location.pathname !== path) return false;
      for (const [key, value] of params.entries()) {
        if (current.get(key) !== value) return false;
      }
      return true;
    }
    if (path === "/applier/dashboard") {
      return location.pathname === path && !location.search.includes("tab=saved");
    }
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card border-t border-border z-50 safe-area-inset-bottom">
      <div className="flex justify-around items-center h-16 max-w-screen-xl mx-auto px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.to);

          return (
            <button
              key={item.to}
              onClick={() => handleNavigation(item.to)}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                active
                  ? "text-primary dark:text-accent"
                  : "text-gray-600 dark:text-gray-400"
              }`}
            >
              <Icon className={`w-6 h-6 ${active ? "stroke-2" : "stroke-1"}`} />
              <span className={`text-xs mt-1 ${active ? "font-semibold" : "font-normal"}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
